module.exports = __webpack_public_path__ + "e715ead2f13da3df7adac6f0c173466b.MP3";